import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import styled, { css } from 'styled-components'
import { getColor } from '../colors'
import { isRouter } from '@rst/libs-ts'
import { ThemeType } from '../theme/create'
import { useInteractionDisabled, useLinkHandler } from '../../libs'

export const themeFont = ({
	theme,
	isHeadFont,
}: {
	theme: ThemeType
	isHeadFont?: boolean
}) => {
	if (theme.font) {
		if (isHeadFont)
			return theme.font.family_head
				? `'${theme.font.head}', ${theme.font.family_head}`
				: `'${theme.font.head}'`
		return theme.font.family_main
			? `'${theme.font.main}', ${theme.font.family_main}`
			: `'${theme.font.main}'`
	}
	return 'Inter'
}

export const themeFontStretch = ({ theme }: { theme: ThemeType }) =>
	theme.fontStretch || 'normal'

// TODO: убрать [key:string]: any
const Text = styled.span<{ isHeadFont?: boolean; [key: string]: any }>`
	font: normal 400 ${themeFontStretch} 16px/100% ${themeFont};
	color: inherit;
`

export type LinkType = React.HTMLAttributes<any> & {
	className?: string
	white?: boolean
	href?: string
	to?: string
	noStyle?: boolean
	noUnderline?: boolean
	[key: string]: any
}

export const useLink = ({
	children,
	to,
	href,
	className = '',
	...props
}: LinkType) => {
	const disabled = useInteractionDisabled()

	const { handler } = useLinkHandler()

	const link = !isRouter ? { href: to || href } : { to, href }

	const linkProps = handler ? handler(link) : link

	const router = isRouter && to && !disabled ? RouterLink : 'a'

	const disableProps = disabled
		? { href: 'javascript:void(0)', target: '_self' }
		: {}

	return {
		className,
		as: router,
		...linkProps,
		...props,
		...disableProps,
		children,
	}
}

const Link: React.FC<LinkType> = props => {
	const linkProps = useLink(props)

	return <StyledLink {...linkProps} />
}

type StyledLinkPropsType = {
	white: boolean
	noStyle: boolean
	noUnderline: boolean
}

export const linkCss = css`
	cursor: pointer;
	transition: color 0.2s;

	${({ white, noStyle, noUnderline }: StyledLinkPropsType) =>
		!noStyle &&
		(white
			? css`
					${!noUnderline && `text-decoration-line: underline;`}
					color: #ffffff;

					&:hover {
						text-decoration-line: none;
					}
					&:active {
						color: rgba(255, 255, 255, 0.6);
					}
			  `
			: css`
					color: ${getColor(x => x.primary.main)};

					&:hover {
						${!noUnderline && `text-decoration-line: underline;`}
					}

					&:active {
						color: ${getColor(x => x.primary.dark)};
					}
			  `)}
`

const StyledLink = styled(Text)`
	${linkCss}
`

export { Text, Link }
